import React from "react";
import { H2, Text, Button, Box, CircleLoader, Link } from "@atoms";
import { CenteredBoxLayout } from "@molecules";
import { RailsUrl, constants } from "@services";
// import styled from "@emotion/styled";

// == Types ================================================================

interface IProps {
  // beneficiary: CampaignBeneficiaryQuery_Campaign_beneficiary;
  // location: $FixMe;
}

// == Constants ============================================================

BeneficiarySuccess.defaultProps = {};

// == Component ============================================================

export default function BeneficiarySuccess(props: IProps) {
  return (
    <CenteredBoxLayout p={[4, 4, 5]}>
      <Box textAlign="center">
        <CircleLoader />
      </Box>
      <H2 mb={3} textAlign="center">
        Success!
      </H2>
      <Box mb={2}>
        <Text>
          Your payment info has been received and will be reviewed within{" "}
          {constants.BENEFICIARY_REVIEW_DAYS} business days to ensure it's in accordance with our{" "}
        </Text>
        <Link href={RailsUrl.beneficiaryGuidelinesUrl} target="_blank">
          payment approval guidelines.
        </Link>
      </Box>
      <Text as="p" mb={3}>
        In the meantime, continue earning for your team. We will notify you by email once approved
        and you can then request funds anytime.
      </Text>
      <Box textAlign="center">
        <Button width="80%" onClick={() => (window.location.href = RailsUrl.rootUrl)}>
          Go Back To My Team
        </Button>
      </Box>
    </CenteredBoxLayout>
  );
}

// == Styles ===============================================================
